export const ChatHubMethod = {
    RECEIVE_MESSAGES: "ReceiveMessages",
    RECEIVE_MESSAGE: "ReceiveMessage",
    BOT_IS_TYPING: "BotIsTyping",
    UPDATE_SESSION: "UpdateSession",
    WIDGET_IS_TYPING: "WidgetIsTyping",
    AUTHORIZATION_REQUIRED: "AuthorizationRequired",
}

export const MoreOptions = {
    TALK_TO_A_HUMAN: { label: "Talk to a human", value: 1 },
    END_CONVERSATION: { label: "End conversation", value: 2 },
    OPT_OUT_TRANSCRIPT: { label: "Opt out transcript", value: 3 },
    LOG_OUT: { label: "Log out", value: 4 }
}

export const MessageType = {
  NORMAL: 0,
  OPENING: 1,
  CLOSING: 2,
  PROMPT: 3,
  AGENT_JOINED: 4,
  AUTHORISATION: 5,
  TOOL_CALL: 6
};

export const MessageRole = {
  USER: "user",
  BOT: "bot",
  AGENT: "agent",
  SYSTEM: "system",
  FUNCTION:"function"
};

export const ChatClient = {
  WIDGET: 0,
  ADMIN: 1,
};